import { Option } from "../interfaces/form-fields";

export enum ServiceType {
  ROUTING_SERVICE = 1,
  KYC_SERVICE = 2,
  FRAUD_PREVENTION_SERVICE = 3
}

export const SERVICE_TYPES: Option[] = [
  { label: 'Routing Service', value: ServiceType.ROUTING_SERVICE },
  { label: 'KYC Service', value: ServiceType.KYC_SERVICE },
  { label: 'Fraud Prevention Service', value: ServiceType.FRAUD_PREVENTION_SERVICE }
];